import { http } from '../../../../api/http';
import type { PlanillaCabecera, PlanillonData, PlanillaDetalleUpdate, DetalleConcepto } from '../types/planillon';

const ENDPOINT = '/planilla/planilla';

export class PlanillonService {
  // ============ Planillas (Cabecera) ============

  public static async getAll(): Promise<PlanillaCabecera[]> {
    const response = await http.get(ENDPOINT);
    return response.data;
  }

  public static async getByPeriodo(idPeriodo: number): Promise<PlanillaCabecera[]> {
    const response = await http.get(`${ENDPOINT}/periodo/${idPeriodo}`);
    return response.data;
  }

  public static async getById(id: number): Promise<PlanillaCabecera> {
    const response = await http.get(`${ENDPOINT}/${id}`);
    return response.data;
  }

  public static async create(planilla: PlanillaCabecera): Promise<PlanillaCabecera> {
    const response = await http.post(ENDPOINT, planilla);
    return response.data;
  }

  public static async update(id: number, planilla: PlanillaCabecera): Promise<PlanillaCabecera> {
    const response = await http.put(`${ENDPOINT}/${id}`, planilla);
    return response.data;
  }

  public static async delete(id: number): Promise<void> {
    await http.delete(`${ENDPOINT}/${id}`);
  }

  // ============ Generar Detalle ============

  public static async generarDetalle(idPlanilla: number): Promise<PlanillaCabecera> {
    const response = await http.post(`${ENDPOINT}/${idPlanilla}/generar-detalle`);
    return response.data;
  }

  // ============ Cálculo ============

  public static async calcular(idPlanilla: number): Promise<PlanillaCabecera> {
    const response = await http.post(`${ENDPOINT}/${idPlanilla}/calcular`);
    return response.data;
  }

  public static async calcularTrabajador(idPlanilla: number, idTrabajador: number): Promise<unknown> {
    const response = await http.post(`${ENDPOINT}/${idPlanilla}/calcular-trabajador/${idTrabajador}`);
    return response.data;
  }

  // ============ Cambiar Estado ============

  public static async cambiarEstado(idPlanilla: number, nuevoEstado: string): Promise<PlanillaCabecera> {
    const response = await http.put(`${ENDPOINT}/${idPlanilla}/estado`, { nuevoEstado });
    return response.data;
  }

  // ============ Detalle (editar días/horas) ============

  public static async updateDetalle(idDetalle: number, detalle: PlanillaDetalleUpdate): Promise<unknown> {
    const response = await http.put(`${ENDPOINT}/detalle/${idDetalle}`, detalle);
    return response.data;
  }

  // ============ Conceptos Manuales ============

  public static async getConceptosDetalle(idDetalle: number): Promise<DetalleConcepto[]> {
    const response = await http.get(`${ENDPOINT}/detalle/${idDetalle}/conceptos`);
    return response.data;
  }

  public static async agregarConceptoManual(idDetalle: number, idConcepto: number, monto: number): Promise<DetalleConcepto> {
    const response = await http.post(`${ENDPOINT}/detalle/${idDetalle}/concepto`, { idConcepto, monto });
    return response.data;
  }

  public static async eliminarConceptoManual(idDetalleConcepto: number): Promise<void> {
    await http.delete(`${ENDPOINT}/detalle-concepto/${idDetalleConcepto}`);
  }

  // ============ Planillón (Vista tabular) ============

  public static async getPlanillon(idPlanilla: number): Promise<PlanillonData> {
    const response = await http.get(`${ENDPOINT}/${idPlanilla}/planillon`);
    return response.data;
  }
}
